import React from 'react';

import {
    Route
} from "react-router-dom";

import Logo from "./Logo"
import List from "./List"

/* Videos */
const VideoList = [
    {
        name: "Logo Animation",
        description: "Teaser Animation des Queerdenker Festival 2.0 Logos",
        route: "logo",
        Component: Logo
    }
]

VideoList.map(item => item.route = `/videos/${item.route}`);

const Videos = () => {
    return <React.Fragment>
        <Route exact path="/videos" component={() => <List videos={VideoList} />} />

        {
            VideoList.map(({ Component, route, name, description }, index) => <Route key={`video-${index}`} path={`${route}`} component={() => {
                const props = {
                    name,
                    description,
                }
                return <Component {...props} />
            }} />)
        }
    </React.Fragment>
}

export default Videos